/**
 * The Engineering group in the side menu: a parent with no page of its own, holding Copy
 * environment and Migrations. App.tsx and the menu test share these declarations.
 *
 * The sider shows a parent with children only when the access-control provider allows `list` on
 * the parent itself (ThemedSiderV2 wraps the group in <CanAccess resource="eng">), then checks
 * each child on its own. So `eng` is allowed when either child's permission is held
 * (accessControlProvider.ts), and a child the user may not open is left out of the group.
 */
import { CopyOutlined, DatabaseOutlined, ToolOutlined } from '@ant-design/icons';
import type { ResourceProps } from '@refinedev/core';
import { ENV_COPY_RESOURCE } from './envCopy/constants';
import { MIGRATIONS_RESOURCE } from './migrations/constants';

export const ENG_RESOURCE_NAME = 'eng';

export const ENG_RESOURCES: ResourceProps[] = [
  { name: ENG_RESOURCE_NAME, meta: { label: 'Engineering', icon: <ToolOutlined /> } },
  {
    // Copy production onto stage or dev. Hidden without eng:env-copy, the permission sf-api checks.
    ...ENV_COPY_RESOURCE,
    meta: { parent: ENG_RESOURCE_NAME, label: 'Copy environment', icon: <CopyOutlined /> },
  },
  {
    // One-off data updates. Hidden without eng:migrations, the permission sf-api checks.
    ...MIGRATIONS_RESOURCE,
    meta: { parent: ENG_RESOURCE_NAME, label: 'Migrations', icon: <DatabaseOutlined /> },
  },
];
